import { render, staticRenderFns } from "./OperUserRole.vue?vue&type=template&id=35f03693&scoped=true&"
import script from "./OperUserRole.vue?vue&type=script&lang=js&"
export * from "./OperUserRole.vue?vue&type=script&lang=js&"
import style0 from "./OperUserRole.vue?vue&type=style&index=0&id=35f03693&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f03693",
  null
  
)

export default component.exports